import React from 'react'
import {Grid , Box} from '@mui/material';
import { Typography } from '@mui/material';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import { makeStyles } from '@mui/styles'
import "leaflet/dist/leaflet.css"
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import L from 'leaflet';

const useStyles = makeStyles({
    map : {
        "& .leaflet-container" : {
            width: "100%" ,
            height: "150px"
        }
    } ,
    root : {
        paddingLeft : "10%" , 
        paddingRight : "10%" , 
        direction : "rtl" , 
        marginTop : "5%" , 
        paddingBottom : "5%" , 
        backgroundColor : "#235F83" , 
        paddingTop : "5%"
    } ,
    links : {
        color : "white" , 
        fontSize : "14px" , 
        lineHeight : "36px" , 
        fontFamily : "Vazir" , 
        textDecoration : "none"
    } ,
});

const ContactWithUs = (props) => {
    
    const classes = useStyles();

    let DefaultIcon = L.icon({
        iconUrl: icon,
    });
    
    L.Marker.prototype.options.icon = DefaultIcon;
    
    const typographyStyles = {
        footerSectionTitle : {
            fontSize : "24px" , 
            fontWeight : 500 , 
            marginBottom : "32px" , 
            color : "white" , 
            fontFamily : "Vazir"
        } , 
        aboutUsText : {
            fontSize : "14px" , 
            color : "white" , 
            fontFamily : "Vazir" , 
            lineHeight : "36px"
        } , 
        contactWithUsText : {
            color : "white" , 
            fontSize : "14px" ,  
            lineHeight : "36px" , 
            fontFamily : "Vazir"
        }
    }

    return (
        <div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                    <Typography textAlign="center" sx={typographyStyles.footerSectionTitle}>درباره ما</Typography>
                    <Typography textAlign="justify" sx={typographyStyles.aboutUsText}>
                    پلتفرم کشاورزی هوشمند وسترا دیجیتال به منظور ایجاد زیست بومی برای خدمات مختلف حوزه کشاورزی هوشمند
در حلقه های مختلف آن، اعم از حلقه تدارک منابع و نهاده ها، تولید، توزیع و عمده فروشی، خرده فروشی و قابلیت ردیابی
محصولات کشاورزی برای مصرف کنندگان طراحی شده است. مسیر شکل گیری و رشد این زیست بوم از تعامل با کنشگران
موجود و ایجاد هم افزایی بین خدمات زیست بوم و کمک به توسعه مقیاس خدمات از طریق این هم افزایی است. 
                    </Typography>
                </Grid> 
                <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                    <Typography textAlign="center" sx={typographyStyles.footerSectionTitle}>لینک های مرتبط</Typography>
                    <div style={{paddingRight : "36px"}}>
                        <a href="https://sarvban.com/" target="_blank" rel="noopener noreferrer" className={classes.links}>
                            ۱ - سروبان
                        </a>
                        <br/>
                        <a href="https://www.kavoshgaran.org/" target="_blank" rel="noopener noreferrer" className={classes.links}>
                            ۲- کاوشگران آب
                        </a>
                        <br/>
                        <a href="https://www.siranguav.ir/" target="_blank" rel="noopener noreferrer" className={classes.links}>
                            ۲- پهپاد سیرنگ
                        </a>
                    </div>
                </Grid> 
                <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                    <Typography textAlign="center" sx={typographyStyles.footerSectionTitle}>ارتباط با ما</Typography>
                    <Typography   textAlign="justify" sx={typographyStyles.contactWithUsText}>
                        {"آدرس : تهران ، بلوار میرداماد ، شماره ۴۳۰ - ساختمان مرکزی - ساختمان هزاره"}
                    </Typography>
                    <Typography textAlign="justify" sx={typographyStyles.contactWithUsText}>
                        {"شماره تماس :  ۸۲۸۹۰-۰۲۱"}
                    </Typography>
                    <Typography textAlign="justify" sx={typographyStyles.contactWithUsText}>
                        {" کد پستی : ۱۹۶۹۷۷۴۵۱۱  "}
                    </Typography>
                    <Typography textAlign="justify" sx={typographyStyles.contactWithUsText}>
                        {"  پست الکترونیکی : info@bbi.ir  "}
                    </Typography>   
                    <div style={{width : "30vw" , height : "20vh" , marginTop : "2vh"}} className={classes.map}>
                        <MapContainer center={[35.762215, 51.415979]} zoom={17}>
                            <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker position={[35.762215, 51.415979]} icon={DefaultIcon}>
                                <Popup>ساختمان هزاره سوم بانک پاسارگاد شرکت جهانپارس</Popup>
                            </Marker>
                        </MapContainer>
                    </div>

                </Grid> 

            </Grid>
        </div>
        
    );
};

export default ContactWithUs;
